export default defineNuxtRouteMiddleware(async (to: any, from: any) => {
  const { waitForUserData } = usePiniaHydration();

  // Wait for complete hydration and get user data
  const { isAuthenticated, user, userData } = await waitForUserData();

  if (!isAuthenticated) {
    return;
  }

  if (!user) {
    debug('🔄 Middleware: User data not found, fetching...');
    await userData.fetchUserProfile({ force: true });
  }

  const { isContainmentMiddlewareEnabled } = useModulesValidation();

  if (!isContainmentMiddlewareEnabled.value) {
    return;
  }

  const { $auth } = useNuxtApp();
  const { getRouteBaseName, goToLocaleRoute } = useRoutes();
  const routeName = getRouteBaseName(to);

  if ($auth.isAnRouteAlwaysAllowed(routeName)) {
    return;
  }

  const { $containment } = useNuxtApp();
  const { isValidationModuleEnabled } = useModulesValidation();

  async function redirectIfPending() {
    const fromRouteName = getRouteBaseName(from);

    if (fromRouteName === routeName || !fromRouteName) {
      $containment.closeVerificationModal();

      return await goToLocaleRoute({ name: 'index' });
    }

    return abortNavigation();
  }

  if (isValidationModuleEnabled('global')) {
    await $containment.fetchCurrentPending('global');

    if ($containment.hasPendencyOn('global')) {
      return await goToLocaleRoute({
        name: 'pending',
      });
    }
  }

  if (isValidationModuleEnabled('casino')) {
    const { isContainmentCasinoListEnabled } = useModulesValidation();
    const checkCasinoPending = ref(false);

    if (
      isContainmentCasinoListEnabled.value &&
      $auth.isAnRestrictedRouteCasinoList(routeName)
    ) {
      checkCasinoPending.value = true;
    }

    if ($auth.isAnRestrictedRouteCasinoGame(routeName)) {
      checkCasinoPending.value = true;
    }

    if (checkCasinoPending.value) {
      await $containment.fetchCurrentPending('casino');

      if ($containment.hasPendencyOn('casino')) {
        $containment.openVerificationModal('casino');

        return redirectIfPending();
      }
    }
  }

  if (
    $auth.isAnRestrictedRouteSports(routeName) &&
    isValidationModuleEnabled('sports')
  ) {
    await $containment.fetchCurrentPending('sports');

    if ($containment.hasPendencyOn('sports')) {
      $containment.openVerificationModal('sports');

      return redirectIfPending();
    }
  }
});
